import httpClient from './httpClient';

const END_POINT = '/api/modules';
const getAllModules = (perPage = null, page = null, sort = null, filterList = '') => {
    let moduleApi = END_POINT;
    moduleApi += filterList != '' ? '?' + filterList : '';
    moduleApi += filterList == '' && perPage != null ? `?itemsPerPage= ${perPage} &page= ${page} ${sort}` : '';
    moduleApi += filterList != '' && perPage != null ? `&itemsPerPage= ${perPage} &page= ${page} ${sort}` : '';
    return httpClient.get(moduleApi);
};
const updateModule = (id, module) => httpClient.put(END_POINT + '/' + id, module);
const addModule = module => httpClient.post(END_POINT, module);
const deleteModule = id => httpClient.post(END_POINT + '/delete/' + id, {});

export {
    getAllModules,
    updateModule,
    deleteModule,
    addModule
};
